import { HeroIcon } from './NavIcons';
import React from 'react';
import BRAND from '../brand';
import { getPlatform, openPlatformLink } from '../platform';
import { maxBotUrl } from '../utils/attribution';

function DeliveryCostDisplay({ loading, calc }) {
  // Loading и success — бесшумно (никакой плашки, никакого моргания).
  // Цена доставки показывается только в детализации сумм ниже (OrderSummary).
  if (loading) return null;
  if (!calc) return null;

  if (calc.error) {
    return (
      <div style={{
        padding: '12px',
        background: '#FFEBEE',
        borderRadius: '8px',
        marginBottom: '16px',
        fontSize: '12px',
        color: '#C62828'
      }}>
        {calc.error}
      </div>
    );
  }

  if (calc.requires_negotiation) {
    return (
      <div style={{
        padding: '12px',
        background: 'linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)',
        border: '1px solid #FFB74D',
        borderRadius: '8px',
        marginBottom: '16px'
      }}>
        <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '8px', color: '#E65100' }}>
          <HeroIcon name="alert" size={16} color="currentColor" inline /> Требуется индивидуальное согласование
        </div>
        <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
          {calc.zone ? `Расстояние: ${calc.zone}` : 'Адрес за пределами зоны доставки'}
          {calc.distance && ` (${calc.distance} км)`}
        </div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          {(getPlatform() === 'max' || BRAND.supportUrl) ? (<>
          Для оформления заказа свяжитесь с{' '}
          <button
            type="button"
            onClick={() => {
              const platform = getPlatform();
              if (platform === 'max') {
                openPlatformLink(maxBotUrl());
              } else {
                openPlatformLink(BRAND.supportUrl);
              }
            }}
            style={{
              background: 'none', border: 'none', padding: 0,
              color: '#2196F3', textDecoration: 'underline', cursor: 'pointer',
              font: 'inherit',
            }}
          >
            поддержкой
          </button>.
          </>) : (<>Для оформления заказа свяжитесь с нами.</>)}
        </div>
      </div>
    );
  }

  // Цена показывается только в детализации сумм ниже (OrderSummary) —
  // отдельная плашка дублировала и зря фокусировала внимание на расходе.
  return null;
}

export default DeliveryCostDisplay;
